export default __webpack_public_path__ + "static/media/p7-9.17db2a71.png";